const LABELS_GOAL = {
  patrimony: "Faire fructifier le patrimoine",
  retirement: "Préparer la retraite",
  transmission: "Optimiser la transmission",
  revenue: "Générer des revenus complémentaires",
};

const LABELS_PROFIL = {
  conservateur: "Conservateur",
  equilibre: "Équilibré",
  dynamique: "Dynamique",
};

const LABELS_ENVELOP = {
  epargne: "Liquidité et épargne <br>de bilan",
  assuranceVie: "Assurance vie",
  pea: "PEA",
  compteTitres: "Compte-titres",
  per: "PER**",
};

const LABELS_ASSET = {
  action: "Action",
  obligation: "Obligation",
  immobilier: "Immobilier",
  fondsEuros: "Fonds en Euros",
  diversification: "Diversification",
};

const PATRIMONY_STEPS = [25e4, 35e4, 5e5, 1e6, 5e6];

// ===== MATRICE D'ALLOCATION  =====
// Structure: allocations[profil][retraite][patrimony500k]
// Pourcentages calculés depuis les montants Excel (Matrice.xlsx)
const MyProposalAllocations = {
  conservateur: {
    false: {
      // Retraite = NON
      true: {
        // >= 500k (CRN+)
        epargne: { pct: 6.7 },
        assuranceVie: {
          pct: 66.7,
          action: 20,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 80,
          diversification: 0,
        },
        pea: {
          pct: 10,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 16.7,
          action: 90,
          obligation: 0,
          immobilier: 10,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
      },
      false: {
        // < 500k (CRN-)
        epargne: { pct: 20 },
        assuranceVie: {
          pct: 64,
          action: 20,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 80,
          diversification: 0,
        },
        pea: {
          pct: 16,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
      },
    },
    true: {
      // Retraite = OUI
      true: {
        // >= 500k (CRO+)
        epargne: { pct: 6.7 },
        assuranceVie: {
          pct: 61.3,
          action: 20,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 80,
          diversification: 0,
        },
        pea: {
          pct: 10,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 15.3,
          action: 90,
          obligation: 0,
          immobilier: 10,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 6.7,
          action: 5,
          obligation: 5,
          immobilier: 10,
          fondsEuros: 80,
          diversification: 0,
        },
      },
      false: {
        // < 500k (CRO-)
        epargne: { pct: 20 },
        assuranceVie: {
          pct: 48,
          action: 20,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 80,
          diversification: 0,
        },
        pea: {
          pct: 12,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 20,
          action: 5,
          obligation: 5,
          immobilier: 10,
          fondsEuros: 80,
          diversification: 0,
        },
      },
    },
  },
  equilibre: {
    false: {
      true: {
        // ERN+
        epargne: { pct: 6.7 },
        assuranceVie: {
          pct: 58.3,
          action: 30,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 60,
          diversification: 0,
        },
        pea: {
          pct: 10,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 25,
          action: 80,
          obligation: 0,
          immobilier: 10,
          fondsEuros: 0,
          diversification: 10,
        },
        per: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
      },
      false: {
        // ERN-
        epargne: { pct: 15 },
        assuranceVie: {
          pct: 59.5,
          action: 30,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 60,
          diversification: 0,
        },
        pea: {
          pct: 25.5,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
      },
    },
    true: {
      true: {
        // ERO+
        epargne: { pct: 6.7 },
        assuranceVie: {
          pct: 53.7,
          action: 30,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 60,
          diversification: 0,
        },
        pea: {
          pct: 10,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 23,
          action: 80,
          obligation: 0,
          immobilier: 10,
          fondsEuros: 0,
          diversification: 10,
        },
        per: {
          pct: 6.7,
          action: 5,
          obligation: 5,
          immobilier: 10,
          fondsEuros: 80,
          diversification: 0,
        },
      },
      false: {
        // ERO-
        epargne: { pct: 15 },
        assuranceVie: {
          pct: 49,
          action: 30,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 60,
          diversification: 0,
        },
        pea: {
          pct: 21,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 15,
          action: 5,
          obligation: 5,
          immobilier: 10,
          fondsEuros: 80,
          diversification: 0,
        },
      },
    },
  },
  dynamique: {
    false: {
      true: {
        // DRN+
        epargne: { pct: 5 },
        assuranceVie: {
          pct: 51,
          action: 40,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 50,
          diversification: 0,
        },
        pea: {
          pct: 10,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 34,
          action: 70,
          obligation: 0,
          immobilier: 10,
          fondsEuros: 0,
          diversification: 20,
        },
        per: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
      },
      false: {
        // DRN-
        epargne: { pct: 10 },
        assuranceVie: {
          pct: 54,
          action: 40,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 50,
          diversification: 0,
        },
        pea: {
          pct: 36,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
      },
    },
    true: {
      true: {
        // DRO+
        epargne: { pct: 5 },
        assuranceVie: {
          pct: 47,
          action: 40,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 50,
          diversification: 0,
        },
        pea: {
          pct: 10,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 31.3,
          action: 70,
          obligation: 0,
          immobilier: 10,
          fondsEuros: 0,
          diversification: 20,
        },
        per: {
          pct: 6.7,
          action: 5,
          obligation: 5,
          immobilier: 10,
          fondsEuros: 80,
          diversification: 0,
        },
      },
      false: {
        // DRO-
        epargne: { pct: 10 },
        assuranceVie: {
          pct: 48,
          action: 40,
          obligation: 10,
          immobilier: 0,
          fondsEuros: 50,
          diversification: 0,
        },
        pea: {
          pct: 32,
          action: 100,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        compteTitres: {
          pct: 0,
          action: 0,
          obligation: 0,
          immobilier: 0,
          fondsEuros: 0,
          diversification: 0,
        },
        per: {
          pct: 10,
          action: 5,
          obligation: 5,
          immobilier: 10,
          fondsEuros: 80,
          diversification: 0,
        },
      },
    },
  },
};

// Modes de gestion selon le niveau de connaissance
const MyProposalManagementMethods = {
  novice: { mandat: 95, conseille: 0, depot: 5 },
  intermediaire: { mandat: 80, conseille: 15, depot: 5 },
  expert: { mandat: 65, conseille: 30, depot: 5 },
  unknown: { mandat: 95, conseille: 0, depot: 5 },
};

const COLORS = ["#002725", "#27514D", "#34746C", "#B1C8B6", "#D9F0DE"];

export {
  LABELS_GOAL,
  LABELS_PROFIL,
  LABELS_ENVELOP,
  LABELS_ASSET,
  COLORS,
  PATRIMONY_STEPS,
  MyProposalAllocations,
  MyProposalManagementMethods,
};
